import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface UpdateMemoryParams {
  id: string
  description?: string
  sharedWithAccountIds?: string[]
}

const updateMemory = async ({ id, ...body }: UpdateMemoryParams): Promise<void> => {
  await api.patch(`/memories/${id}`, body)
}

export const useUpdateMemory = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, UpdateMemoryParams>({
    mutationFn: updateMemory,
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['memory', id] })
      queryClient.invalidateQueries({ queryKey: ['myMemories'] })
      queryClient.invalidateQueries({ queryKey: ['contact-memories'] })
      queryClient.invalidateQueries({ queryKey: ['memories'] })
    },
  })
}
